import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.module.scss'

export default function withFontTheme(Component) {
  function WithFontTheme(props) {
    const { theme } = props
    return (
      <div className={theme === 'wsj' ? styles.fontTheme : ''}>
        <Component {...props} />
      </div>
    )
  }
  WithFontTheme.propTypes = { theme: PropTypes.string.isRequired }
  return WithFontTheme
}
